import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import Toggle, {
  FilterDropdownToggle,
  FilterInput
} from '../../../components/ReusableComponents/FilterToggle/index'
import RepeatingValueFilter from '../../../components/ReusableComponents/RepeatingValueFilter/index'
import bookingMatchNames from '../../../main/bookingMatchNames'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const FilterBar = ({ setFilterVal, filterVals, billableBookings }) => {
  const {
    showRejected,
    showNonRejected,
    rateToFilter,
    trackingToFilter,
    rateCategoryToFilter,
    filteredConversionReason,
    omnisearchVal,
    priorStayCount,
    showAnomaly
  } = filterVals

  const [rates, setRates] = useState()
  const [trackings, setTrackings] = useState()
  const [rateCategories, setRateCategories] = useState()

  const query = useQuery()

  const searchQuery = query.get('q')

  useEffect(() => {
    if (searchQuery) {
      setFilterVal('omnisearch', searchQuery)
    }
  }, [searchQuery, setFilterVal])

  useEffect(() => {
    const { rates, trackings, rateCategories } = billableBookings.reduce(
      (o, b) => {
        if (b.convertedRateCodeKind) {
          if (o.rateCategories[b.convertedRateCodeKind]) {
            o.rateCategories[b.convertedRateCodeKind] =
              o.rateCategories[b.convertedRateCodeKind] + 1
          } else {
            o.rateCategories[b.convertedRateCodeKind] = 1
          }
        }

        if (o.rates[b.convertedRateCode]) {
          o.rates[b.convertedRateCode] = o.rates[b.convertedRateCode] + 1
        } else {
          o.rates[b.convertedRateCode] = 1
        }

        if (o.trackings[b.convertedTrackingCode]) {
          o.trackings[b.convertedTrackingCode] = o.trackings[b.convertedTrackingCode] + 1
        } else {
          o.trackings[b.convertedTrackingCode] = 1
        }
        return o
      },
      { rates: {}, trackings: {}, rateCategories: {} }
    )

    setRates(rates)
    setTrackings(trackings)
    setRateCategories(rateCategories)
  }, [billableBookings])

  return (
    <>
      <Toggle onClick={() => setFilterVal('rejected')} on={showRejected}>
        Won't charge
      </Toggle>
      <Toggle onClick={() => setFilterVal('nonRejected')} on={showNonRejected}>
        Will charge
      </Toggle>
      <Toggle
        onClick={() => setFilterVal('anomaly')}
        on={showAnomaly}
        title="30+ days before booking&#013;or&#013;10+ prior bookings&#013;or&#013;Lname + ZIP match&#013;or&#013;partial guest name match"
      >
        Anomaly
      </Toggle>
      <RepeatingValueFilter
        allValues={rates}
        selectedValue={rateToFilter}
        handleClick={rate => setFilterVal('rate', rate)}
        valueName="rate code"
      />
      <RepeatingValueFilter
        allValues={trackings}
        selectedValue={trackingToFilter}
        handleClick={tracking => setFilterVal('tracking', tracking)}
        valueName="tracking info"
      />
      <RepeatingValueFilter
        allValues={rateCategories}
        selectedValue={rateCategoryToFilter}
        handleClick={rateCategory => setFilterVal('rateCategory', rateCategory)}
        valueName="rate category"
      />
      <FilterDropdownToggle
        value={filteredConversionReason}
        options={['Any conversion reason', ...Object.values(bookingMatchNames)]}
        onSelect={value => setFilterVal('conversionReason', value)}
        on={filteredConversionReason !== 'Any conversion reason'}
      />
      <FilterDropdownToggle
        value={priorStayCount}
        options={['Any prior stays', '0-3', '0-5', '4+', '6+']}
        onSelect={value => setFilterVal('priorStaysCount', value)}
        on={priorStayCount !== 'Any prior stays'}
      />
      <FilterInput
        on={omnisearchVal !== '' && omnisearchVal.length > 2}
        value={omnisearchVal}
        onChange={val => setFilterVal('omnisearch', val)}
        placeholder="Search anything..."
      />
    </>
  )
}

export default FilterBar
